

























































import { Component, Prop, Vue } from 'vue-property-decorator';

const PAD = 4;

/**
 * Minigrafica de una serie con escala fija: las zonas de color salen de los
 * mismos limites "regular" y "mal" que el resto de la pantalla, asi un valor
 * chico no parece un pico. SVG plano, sin libreria.
 */
@Component
export default class TrendChart extends Vue {
    @Prop({ required: true }) readonly title!: string;

    @Prop({ default: '' }) readonly unit!: string;

    @Prop({ required: true }) readonly values!: number[];

    /** Desde aca es "regular". */
    @Prop({ required: true }) readonly warn!: number;

    /** Desde aca es "mal". */
    @Prop({ required: true }) readonly bad!: number;

    @Prop({ default: '' }) readonly explanation!: string;

    /** Falso cuando el valor ya se muestra en la tarjeta de arriba. */
    @Prop({ default: true }) readonly showHeader!: boolean;

    width = 300;

    height = 80;

    hover: number | null = null;

    get latest(): number {
        return this.values.length ? this.values[this.values.length - 1] : 0;
    }

    get current(): string {
        return this.format(this.latest);
    }

    format(value: number): string {
        return value.toFixed(this.unit.trim() === '%' ? 1 : 0);
    }

    get pill(): { label: string; cls: string; dot: string } {
        if (this.latest >= this.bad) {
            return { label: 'Mal', cls: 'bg-red-100 text-red-700', dot: '#dc2626' };
        }

        return this.latest >= this.warn
            ? { label: 'Regular', cls: 'bg-yellow-100 text-yellow-800', dot: '#d97706' }
            : { label: 'Bien', cls: 'bg-green-100 text-green-700', dot: '#059669' };
    }

    /** El eje llega a 1.5 veces "mal" y solo crece si un valor lo pasa. */
    get top(): number {
        return Math.max(this.bad * 1.5, ...this.values);
    }

    yOf(value: number): number {
        const inner = this.height - PAD * 2;

        return this.height - PAD - (Math.min(value, this.top) / this.top) * inner;
    }

    get warnY(): number {
        return this.yOf(this.warn);
    }

    get badY(): number {
        return this.yOf(this.bad);
    }

    get endY(): number {
        return (this.yOf(this.latest) / this.height) * 100;
    }

    get ago(): string {
        const seconds = this.values.length;

        return seconds >= 120 ? `${Math.round(seconds / 60)} min` : `${seconds} s`;
    }

    get points(): string {
        const steps = Math.max(1, this.values.length - 1);

        return this.values
            .map((value, index) => `${(index / steps) * this.width},${this.yOf(value)}`)
            .join(' ');
    }

    get hoverX(): number {
        const steps = Math.max(1, this.values.length - 1);

        return this.hover === null ? 0 : (this.hover / steps) * 100;
    }

    onMove(event: MouseEvent) {
        const box = this.$refs.box as HTMLElement;
        const { left, width } = box.getBoundingClientRect();
        const ratio = Math.min(1, Math.max(0, (event.clientX - left) / width));

        this.hover = Math.round(ratio * Math.max(0, this.values.length - 1));
    }
}
